import React from "react";

import { useHistory } from "react-router-dom";

import { Row, Col } from "react-bootstrap";

import { ArrowRight } from "iconsax-react";

import { StyledContainer, StyledArrowBack } from "./styledLayoutPurchase";
import { SubscriptionBackground } from "../../../../containers/purchase/purchase/styledPurchasePage";

const LayoutPurchaseComponent = ({
  children,
  cardTitle,
  $width,
  $height,
  rowClassName,
}) => {
  const history = useHistory();
  return (
    <SubscriptionBackground className="pb-5 pt-1 pt-md-5">
      <StyledContainer
        $width={$width}
        $height={$height}
        className="mx-auto mb-5 mt-5 p-4 d-flex flex-column justify-content-between align-items-center"
      >
        <Row className="w-100">
          <Col xs={1} md={5} className="p-0 text-end">
            <StyledArrowBack onClick={() => history.goBack()}>
              <ArrowRight size="25" color="var(--text-color-dark)" />
            </StyledArrowBack>
          </Col>
          <h1 className="title col-11 col-md-7 p-0 text-center text-md-end">
            {cardTitle}
          </h1>
        </Row>
        <Row className={`h-100 ${rowClassName}`}>{children}</Row>
      </StyledContainer>
    </SubscriptionBackground>
  );
};

export default LayoutPurchaseComponent;
